import React from 'react';
import { CommonButton } from '../../../components';
import { getSearchKey, useAppSelector } from '@zonofi/zono-money-store';

interface CreateTagViewProps {
  onCreateTag: (tag: string) => void;
}

export const CreateTagView: React.FC<CreateTagViewProps> = ({
  onCreateTag,
}) => {
  const tagName = useAppSelector(getSearchKey);
  return (
    <div className="tag-modal-create-view">
      <div className="tag-modal-create-view-not-found font-medium">
        No existing tag found!!
      </div>
      {tagName.length > 0 && (
        <CommonButton
          text={`Create "${tagName}"`}
          onPress={() => onCreateTag(tagName)}
          buttonStyle="tag-modal-create-view-btn"
          textStyle="tag-modal-create-view-btn-text"
        />
      )}
    </div>
  );
};
